import { ErrorLikeError } from "../ErrorLikeError";
import { NonErrorThrownError } from "../NonErrorThrownError";

function asErrorLike(thrown: unknown): {
  name: string;
  message: string;
  stack?: string;
  org: object;
} | null {
  // functions can have properties assigned
  if (
    (typeof thrown !== "object" && typeof thrown !== "function") ||
    thrown == null
  ) {
    return null;
  }
  if (
    !("name" in thrown && typeof thrown.name === "string") ||
    !("message" in thrown && typeof thrown.message === "string")
  )
    return null;
  if ("stack" in thrown) {
    if (typeof thrown.stack !== "string") return null;
    if (!thrown.stack.startsWith(thrown.name)) return null;
    return {
      name: thrown.name,
      message: thrown.message,
      stack: thrown.stack,
      org: thrown,
    };
  }
  return {
    name: thrown.name,
    message: thrown.message,
    org: thrown,
  };
}

export function asError(thrown: unknown) {
  if (thrown instanceof Error) return thrown;
  const errorLike = asErrorLike(thrown);
  if (errorLike) return new ErrorLikeError(errorLike);
  return new NonErrorThrownError(thrown);
}
